import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

if (import.meta.env.DEV) {
  console.log("\n🔧 Frontend Environment:");
  console.log(`   Mode: ${import.meta.env.MODE}`);
}

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// Only hydrate when the server actually injected SSR content.
// hasChildNodes() returns true even for HTML comment nodes (<!--ssr-outlet-->),
// so we check for real element children instead.
const hasSsrContent = container.hasChildNodes() && container.children.length > 0;

if (hasSsrContent) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
